import { RequestService } from '../request';

import { IStudentQuiz } from './student-quiz.contract';

export class StudentQuizService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async getStudentQuiz(studentQuizId: string) {
    return this.fetcher<IStudentQuiz>(`/student-quiz/${studentQuizId}`);
  }
}
